import { render, staticRenderFns } from "./edit-staff-modal.vue?vue&type=template&id=40c47330"
import script from "./edit-staff-modal.vue?vue&type=script&lang=js"
export * from "./edit-staff-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-staff-modal.vue?vue&type=style&index=0&id=40c47330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports